// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleCircleFilledSvg from "@fishx/icons-svg/es/asn/DribbbleCircleFilled";
import FishxIcon from '../components/FishxIcon';

var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleCircleFilledSvg
  }));
};

DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
export default React.forwardRef(DribbbleCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DribbbleCircleFilled.js
// module id = 2476
// module chunks = 0